import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

type TotalNewTasksSelector = (state: ReduxState) => number
const getTotalNewTasks: TotalNewTasksSelector = state => state.tasksQueue.totalNewTasks

export const totalNewTasksSelector: TotalNewTasksSelector = createSelector(getTotalNewTasks, totalNew => totalNew)
